export const AcSanitize = input => {
  let result = input.replace(/[^\w. ]/gi, function (c) {
    return '&#' + c.charCodeAt(0) + ';';
  });

  return result.trim();
};

export default AcSanitize;
